export default "__VITE_PUBLIC_ASSET__c479b4ca__"